import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
} from "react-bootstrap";
import { login } from "../../services/api";
import { setStoredUser } from "../../utils/authStorage";
import { useTheme } from "../../contexts/ThemeContext";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const { orgName, logoUrl } = useTheme();
  const [logoFailed, setLogoFailed] = useState(false);
  const showLogo = logoUrl && !logoFailed;
  const [formData, setFormData] = useState({
    userid: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await login(formData);

      if (response.data.success) {
        // Simpan user data ke localStorage
        setStoredUser(response.data.data);

        // Redirect berdasarkan role
        const role = response.data.data.role;
        if (role === "R.48") {
          navigate("/admin/profil-penyelia");
        } else {
          navigate("/admin/dashboard");
        }
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err.response?.data?.message || "Login gagal. Silakan coba lagi.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={5} lg={4}>
            <Card className="login-card shadow-lg">
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <div className="login-logo">
                    {showLogo ? (
                      <img
                        src={logoUrl}
                        alt={orgName || "Logo Lembaga"}
                        className="login-logo-img"
                        onError={() => setLogoFailed(true)}
                      />
                    ) : (
                      <i className="fas fa-shield-halved"></i>
                    )}
                  </div>
                  <h2 className="login-title mt-3">Login</h2>
                  {orgName && (
                    <p className="text-muted login-org-name">{orgName}</p>
                  )}
                </div>

                {error && (
                  <Alert
                    variant="danger"
                    dismissible
                    onClose={() => setError("")}
                  >
                    {error}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <i className="fas fa-user me-2"></i>
                      Username
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="userid"
                      value={formData.userid}
                      onChange={handleChange}
                      placeholder="Masukkan username"
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <i className="fas fa-lock me-2"></i>
                      Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Masukkan password"
                      required
                      disabled={loading}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 btn-login"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Memproses...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Login
                      </>
                    )}
                  </Button>
                </Form>

                <div className="text-center mt-4">
                  <a href="/" className="text-muted text-decoration-none">
                    <i className="fas fa-arrow-left me-2"></i>
                    Kembali ke Website
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
